const listMealPlanInfos = (state) => state.listMealPlanInfo
const MealPlanPriceTotalPax = (state) => state.MealPlanPriceTotalPax
const MealPlanInfoPax = (state) => state.MealPlanInfo

export default {
  listMealPlanInfos,
  MealPlanPriceTotalPax,
  MealPlanInfoPax
}
